// Slash commands of the composer (D36): the fixed list, the partial command being typed (for the autocomplete menu)
// and the parse of a submitted line. A line that names no known command is sent as ordinary text.
import type { MessageKey } from "../../i18n/en.ts";

export const SLASH_COMMANDS = ["clear", "help", "status", "validate", "task", "plan", "fix", "publish", "logs", "guardian", "mcp", "agent", "mode"] as const;
export type SlashCommandName = (typeof SLASH_COMMANDS)[number];

export interface SlashCommand {
  name: SlashCommandName;
  description: MessageKey;
}

export const ALL_SLASH_COMMANDS: readonly SlashCommand[] = SLASH_COMMANDS.map((name) => ({ name, description: `composer.slash.${name}` as MessageKey }));

/** The command prefix being typed (`/` → "", `/st` → "st"), or null when the field is not a bare command yet. */
export function slashQuery(value: string): string | null {
  const m = /^\/([a-z]*)$/i.exec(value);
  return m ? (m[1] ?? "").toLowerCase() : null;
}

/** Commands whose name starts with the query, in the list's order. */
export function matchSlash(query: string, commands: readonly SlashCommand[]): SlashCommand[] {
  return commands.filter((c) => c.name.startsWith(query));
}

/** A submitted line naming a known command (`/task fix login` → task + "fix login"), else null (sent as text). */
export function parseSlash(value: string, commands: readonly SlashCommand[]): { command: SlashCommand; rest: string } | null {
  const m = /^\/([a-z]+)(?:\s+([\s\S]*))?$/i.exec(value.trim());
  if (!m) return null;
  const command = commands.find((c) => c.name === m[1]?.toLowerCase());
  return command ? { command, rest: (m[2] ?? "").trim() } : null;
}
